import { defineStore } from "pinia";
import { attributeService } from "~/services/attribute.service";
import { handleCommonActions } from "~/utils/store.util";
import { usePaginationStore } from "@/stores/common/pagination.store";

export const useAttributeStore = defineStore("attribute", {
    state: () => ({
        
        attributes: [],
        attribute: null,
        response: null,
    }),
    actions: {
        setSearch(payload = {}) {
            this.search = {
                ...this.search,
                ...payload,
            };
        },
        setAvailableFilters(filters = []) {
            this.availableFilters.variants = {};

            filters.map((filter) => {
                if (filter?.type === "category") {
                    this.availableFilters.categories = filter?.items ?? [];
                } else if (filter?.type === "brand") {
                    this.availableFilters.brands = filter?.items ?? [];
                } else if (filter?.type === "unit") {
                    this.availableFilters.units = filter?.items ?? [];
                } else if (filter?.type === "variant") {
                    this.availableFilters.variants[`variant-${filter.name}`] = {
                        title: filter?.name ?? null,
                        items: filter?.items ?? [],
                    };
                }
            });
        },
        // async storeAttribute(payload = {}) {
        //     return await handleCommonActions(async () => {
        //         const response = await attributeService.store(payload);
        //         console.log("response storeAttribute", response);
        //         this.response = response ?? null;
        //     });
        // },
        async fetchAttributes(payload = {}) {
            // const paginationStore = usePaginationStore();
            
            return await handleCommonActions(async () => {
                const response = await attributeService.index({
                    // ...paginationStore.paginationDataForRequest,
                    ...this.search,
                    ...payload,
                });

                const attributes = response?.data ?? [];
                
                this.attributes = [...attributes];

                // paginationStore.setPaginationData(response?.headers ?? {});
                // this.setAvailableFilters(response.data?.filters ?? []);
            });
        },
        async fetchAttribute(id) {
            return await handleCommonActions(async () => {
                const response = await attributeService.getAttribute(id);
                
                this.attribute = response?.data ?? null;
            });
        },
    },
});
